/** @jsxImportSource @emotion/react */

import type { ChangeEventHandler, FocusEventHandler, Ref } from "react";
import { forwardRef } from "react";
import { textareaCSS } from "./Textarea.css";
import type { TextareaCoreProps } from "./Textarea.types";

export const TextareaCore = forwardRef(
  (
    {
      onChange,
      nativeOnBlur,
      nativeOnChange,
      nativeOnFocus,
      maxLength,
      placeholder,
      setIsFocus,
      native,
      ...restProps
    }: TextareaCoreProps,
    ref: Ref<HTMLTextAreaElement>,
  ) => {
    const _onChange: ChangeEventHandler<HTMLTextAreaElement> = (event) => {
      const newValue = event.target.value;

      if (maxLength && newValue.length > maxLength) return;

      nativeOnChange?.(event);
      onChange?.(newValue);
    };

    const _onFocus: FocusEventHandler<HTMLTextAreaElement> = (event) => {
      nativeOnFocus?.(event);
      setIsFocus?.(true);
    };

    const _onBlur: FocusEventHandler<HTMLTextAreaElement> = (event) => {
      nativeOnBlur?.(event);
      setIsFocus?.(false);
    };

    return (
      <textarea
        ref={ref}
        onChange={_onChange}
        css={[textareaCSS]}
        onFocus={_onFocus}
        onBlur={_onBlur}
        placeholder={placeholder}
        maxLength={maxLength}
        {...restProps}
        {...native}
      />
    );
  },
);
